import { toast } from "react-toastify";
import { apiSlice } from "../api/apiSlice";

export const educationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEducations: builder.query({
      query: () => ({
        url: `education?status=true&page=1&count=20`,
      }),
      providesTags: ["Educations"],
    }),

    getSingleEducation: builder.query({
      query: (id) => ({
        url: `education/${id}`,
      }),
      providesTags: ["Education"],
    }),

    addEducation: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `education`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Education added successfully");
        } catch (err) {
          toast.error("An error occurred while adding Education");
        }
      },
      invalidatesTags: ["Educations", "User"],
    }),

    updateEducation: builder.mutation({
      query: ({ id, values }) => ({
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `education/${id}`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Education updated successfully");
        } catch (err) {
          toast.error("An error occurred while updating Education");
        }
      },
      invalidatesTags: ["Educations", "Education", "User"],
    }),

    deleteEducation: builder.mutation({
      query: (id) => ({
        url: `education/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toast.success("Deleted Education successful");
        } catch (err) {
          toast.error("An error occurred while deleting the Education");
        }
      },
      invalidatesTags: ["Educations", "User"],
    }),
  }),
});

export const {
  useGetEducationsQuery,
  useGetSingleEducationQuery,
  useAddEducationMutation,
  useUpdateEducationMutation,
  useDeleteEducationMutation,
} = educationApi;
